import script from "./HrSortableList.vue?vue&type=script&lang=js"
export * from "./HrSortableList.vue?vue&type=script&lang=js"

import "./HrSortableList.vue?vue&type=style&index=0&id=0298ba9b&lang=scss&scoped=true"
import "./HrSortableList.vue?vue&type=style&index=1&id=0298ba9b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0298ba9b"]])

export default __exports__